module.exports = __webpack_public_path__ + "img/存量房_1@2x.3df808aa.png";